<template>
  <div>
    <vm-table
        ref="vmTable"
        height="50vh"
        :filter.sync="filter"
        module="basic"
        url="reserveOrders"
        @select="selectHandle"
        @select-all="selectHandle">
      <div slot="toolbar"/>
      <template slot="adSearch">
        <div class="vm-Search">
          <vm-search label="预留单号">
            <el-input v-model.trim="filter.reservNo" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="发料状态">
            <el-select v-model="filter.status" clearable placeholder="请选择">
              <el-option label="全部" :value="0"/>
              <el-option label="排除已发料" :value="-1"/>
              <el-option label="未发料" :value="1"/>
              <el-option label="部分发料" :value="2"/>
              <el-option label="已发料" :value="3"/>
            </el-select>
          </vm-search>
          <vm-search label="需求日期">
            <div class="block">
              <el-date-picker
                  v-model="filter.plnOutDateStart"
                  value-format="yyyy-MM-dd 00:00:00"
                  type="date"
                  style="width: 190px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.plnOutDateEnd"
                  value-format="yyyy-MM-dd 00:00:00"
                  type="date"
                  style="width: 190px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
          <vm-search label="创建时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.creatorDateStart"
                  value-format="yyyy-MM-dd 00:00:00"
                  type="date"
                  style="width: 190px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.creatorDateEnd"
                  value-format="yyyy-MM-dd 00:00:00"
                  type="date"
                  style="width: 190px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
          <vm-search label="接收人">
            <el-input v-model.trim="filter.GR_RCPT" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="物料编号">
            <el-input v-model.trim="filter.material" placeholder="请输入" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="reservNo" align="center" min-width="120" label="预留单号">
        <template v-slot="scope">
          <span style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.reservNo}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="statusDesc" align="center" width="90" label="发料状态">
        <template v-slot="scope">
          <el-tag v-if="scope.row.status === 1" type="info">未发料</el-tag>
          <el-tag v-if="scope.row.status === 2" type="primary">部分发料</el-tag>
          <el-tag v-if="scope.row.status === 3" type="success">已发料</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="printCount" align="center" width="90" label="打印次数"/>
      <el-table-column prop="sendToApplier" align="center" width="90" label="领料通知">
        <template slot-scope="scope">
          <span v-if="scope.row.sendToApplier===true">已通知</span>
          <span v-else>未通知</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderMoveType" align="center" width="90" label="移动类型"/>
      <el-table-column prop="plnOutDate" align="center" width="150" label="需求日期"/>
      <el-table-column prop="orderId" align="center" min-width="110" label="内部订单号"/>
      <el-table-column prop="gr_RCPT" align="center" width="100" label="接收人"/>
      <el-table-column prop="creatorDate" align="center" width="135" label="创建时间"/>
      <el-table-column
          label="操作"
          align="center"
          width="300"
          fixed="right">
        <template v-slot="scope">
          <el-button v-if="confirmAuth" :disabled="scope.row.status === 3" type="primary" @click="$refs.editPage.open(scope.row.id)">
            发料确认
          </el-button>
          <el-button
              v-if="printAuth"
              type="success"
              :loading="scope.row.printLoading"
              @click="handlePrint(scope.row)">
            打印
          </el-button>
          <el-button v-if="confirmAuth" type="primary" @click="sendToApply(scope.row)">
            领料通知
          </el-button>
          <el-button v-if="editAuth" type="danger" @click="$refs.editPage.open(scope.row.id)">
            编辑预留单
          </el-button>
        </template>
      </el-table-column>
    </vm-table>
    <reserve-order-edit ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import ReserveOrderEdit from "@/views/warehouse/ReserveOrder/ReserveOrderEdit";

  export default {
    name: "ReserveOrderList",
    components: {VmTable, VmSearch,ReserveOrderEdit},
    data() {
      return {
        confirmAuth: this.$auth(407),
        printAuth: this.$auth(408),
        editAuth:this.$auth(473),
        selection: [],
        filter: {
          status: 0,
          postingStatus: "",
          reservNo: "",
          orderMoveType: "",
          GR_RCPT: "",
          creatorDate: "",
          creatorDateStart: "",
          creatorDateEnd: "",
          plnOutDate: "",
          plnOutDateStart: "",
          plnOutDateEnd: "",
          material:"",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {

      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },



      selectHandle(selection) {
        this.selection = selection;
      },

      //下载清单
      buyListDownLoadFile() {
        this.downloadLoading = true;
        this.$http
          .exportFile("basic", "tianchangProductionOrder/export", this.filter)
          .then((resp) => {
            let blob = new Blob([resp.data]);
            let fileName = decodeURI(resp.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.downloadLoading = false;
          })
          .catch(() => {
            this.downloadLoading = false;
          });
      },

      handlePrint(row) {
        this.$set(row, "printLoading", true);
        this.$http.postForFile("basic", `reserveOrders/print/${row.id}`).then((res) => {
          let blob = new Blob([res.data], {type: "application/pdf"});
          let pdfUrl = window.URL.createObjectURL(blob);
          let newWindow = window.open(pdfUrl, "__blank");
          newWindow.document.close();
          newWindow.print();
          this.getList(-1);
        }).finally(() => {
          this.$set(row, "printLoading", false);
        });
      },



      goto(row) {
        console.log(row);
        this.$router.push({
          path: "/ReserveOrderPreview",
          query: {
            billId: row.id,
            $tabName: row.reservNo,
          },
        });
      },
      
      sendToApply(row) {
        this.$http.get("basic",`reserveOrders/sendToApply/${row.id}`)
          .then(()=>{
            this.$message.success("通知成功");
            this.getList(1);
          });
      },

    },
  };
</script>
<style lang="scss" scoped>
</style>
